import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from '../components/common/PublicHeader';
import PublicFooter from '../components/common/PublicFooter';

function PublicLayout() {
  return (
    <div className="surface-page">
      <div className="pointer-events-none fixed inset-0" aria-hidden="true">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 18% 8%, rgba(224, 242, 254, 0.7), transparent 32rem), radial-gradient(circle at 82% 42%, rgba(226, 232, 240, 0.5), transparent 30rem)',
          }}
        />
      </div>

      <PublicHeader />

      <main className="relative pt-16">
        <Outlet />
      </main>

      <PublicFooter />
    </div>
  );
}

export default PublicLayout;
